package com.netguru.multiplatform.charts.grid

import androidx.compose.runtime.*

@Immutable
data class LineParameters(
    val position: Float,
    val value: Number,
)
